module.exports = __webpack_public_path__ + "img/IS.de370346.svg";